export interface MaterialPresetVariant {
  label: string
  color: string       // 'rrggbb' — NO # prefix (matches PrimeNG colorPicker ngModel format)
  opacity: number
  roughness: number
  metalness: number
}

export interface MaterialPresetGroup {
  label: string
  items: MaterialPresetVariant[]
}

export const MATERIAL_PRESETS: readonly MaterialPresetGroup[] = [
  {
    label: 'Glass',
    items: [
      { label: 'Clear',   color: 'f5f5f5', opacity: 0.18, roughness: 0.0,  metalness: 0.0 },
      { label: 'Tinted',  color: '6ba3be', opacity: 0.35, roughness: 0.05, metalness: 0.0 },
      { label: 'Frosted', color: 'e8e8e8', opacity: 0.50, roughness: 0.35, metalness: 0.0 },
    ],
  },
  {
    label: 'Asphalt',
    items: [
      { label: 'New',  color: '343434', opacity: 1.0, roughness: 0.95, metalness: 0.0 },
      { label: 'Worn', color: '4a4a4a', opacity: 1.0, roughness: 0.90, metalness: 0.0 },
      { label: 'Wet',  color: '222222', opacity: 1.0, roughness: 0.35, metalness: 0.0 },
    ],
  },
  {
    label: 'Concrete',
    items: [
      { label: 'Fresh',   color: 'b3b3b3', opacity: 1.0, roughness: 0.92, metalness: 0.0 },
      { label: 'Aged',    color: '8c8c8c', opacity: 1.0, roughness: 0.95, metalness: 0.0 },
      { label: 'Stained', color: '787068', opacity: 1.0, roughness: 0.88, metalness: 0.0 },
    ],
  },
  {
    label: 'Grass',
    items: [
      { label: 'Healthy', color: '3d7a1e', opacity: 1.0, roughness: 0.90, metalness: 0.0 },
      { label: 'Dry',     color: '8a9440', opacity: 1.0, roughness: 0.95, metalness: 0.0 },
      { label: 'Sparse',  color: '6b7a3a', opacity: 1.0, roughness: 0.92, metalness: 0.0 },
    ],
  },
  {
    label: 'Cement',
    items: [
      { label: 'Smooth',   color: 'bab0a2', opacity: 1.0, roughness: 0.80, metalness: 0.0 },
      { label: 'Rough',    color: 'a0968a', opacity: 1.0, roughness: 0.95, metalness: 0.0 },
    ],
  },
  {
    label: 'Ceramic Roof',
    items: [
      { label: 'Terracotta', color: 'c4522a', opacity: 1.0, roughness: 0.65, metalness: 0.0 },
      { label: 'Aged',       color: '9a4020', opacity: 1.0, roughness: 0.80, metalness: 0.0 },
      { label: 'Dark',       color: '6e2e18', opacity: 1.0, roughness: 0.72, metalness: 0.0 },
    ],
  },
  {
    label: 'Steel',
    items: [
      { label: 'Weathered', color: 'a0a0a0', opacity: 1.0, roughness: 0.65, metalness: 0.9 },
    ],
  },
  {
    label: 'Rusted Metal',
    items: [
      { label: 'Light Rust',  color: '8b5a2b', opacity: 1.0, roughness: 0.75, metalness: 0.0 },
      { label: 'Medium Rust', color: '7a4422', opacity: 1.0, roughness: 0.85, metalness: 0.0 },
      { label: 'Heavy Rust',  color: '5c3010', opacity: 1.0, roughness: 0.95, metalness: 0.0 },
    ],
  },
] as const
